<template>
  <div class="data-business-box">
    <video
      src="https://img.aikesaisi.com/lkzh/www/buiness-video.mp4"
      preload="auto"
      muted
      autoplay
      loop
      class="business-box-video"
    />
    <div class="container business-box-concainter">
      <AnimeTitle
        :title="$t('dataBusiness.title')"
        svgRefValue="dataBusinessAnimeTitle"
        :computingTitle="$t('dataBusiness.computingTitle')"
      />
      <div
        class="secondary-title"
        data-animation="fade-scale-up"
        data-once="false"
      >
        {{ $t('dataBusiness.subTitle') }}
      </div>
      <div>
        <div
          data-animation="fade-scale-up"
          data-once="false"
          class="tab-item"
          v-for="(item, index) in localizedTabList"
          :key="index"
          @click="handleTabClick(index)"
          @mouseenter="handleTabHover(index, true)"
          @mouseleave="handleTabHover(index, false)"
          :class="activeIndex == index ? 'tab-active' : ''"
        >
          <img :ref="`tabImg${index}`" :src="getImgSrc(index)" />
          <span>{{ item }}</span>
        </div>
      </div>

      <!-- swiper循环 -->
      <swiper
        data-animation="fade-scale-up"
        data-once="false"
        :slides-per-view="1"
        :space-between="0"
        :allowTouchMove="false"
        ref="businessSwiper"
        @swiper="onSwiper"
        class="data-swiper-box"
        @slideChange="onSlideChange"
      >
        <swiper-slide
          class="business-swiper-item"
          v-for="(item, index) in localizedSwiperItems"
          :key="index"
        >
          <div class="business-swiper-left">
            <div class="swiper-title">{{ item.title }}</div>
            <div class="swiper-sub-title">
              {{ item.subTitle }}
              <span v-if="currentLocale === 'en'">{{ item.subTitle1 }}</span>
            </div>

            <div
              class="swiper-sub-descr"
              v-for="(child, childIndex) in item.list"
              :key="childIndex"
            >
              <span>{{ child.title }}：</span>{{ child.description }}
            </div>
            <RoundedButton
              :borderRadius="25"
              :height="46"
              :textSize="16"
              @click="scrollToAnchor()"
              :width="151"
              class="swiper-btn"
              :customIcon="index === 1 ? demoIcon : ''"
              :showArrow="index !== 1 ? true : false"
              :text="item.btnText"
            />
          </div>

          <div class="business-swiper-right">
            <div class="swiper-child-tab" v-if="index === 0">
              <div
                class="swiper-child-tab-tab-item"
                v-for="(tabItem, tabIndex) in item.tabList"
                :key="tabIndex"
                :class="{ 'is-active': tabIndex === tabActiveIndex }"
                @click="handleChildTabClick(tabIndex)"
              >
                {{ tabItem.title }}
              </div>
            </div>
            <Map
              v-if="index === 2"
              class="swiper-child-tab-tab-item__map"
              :zoom="1.5"
              :layoutCenter="['50%', '60%']"
            />
            <video
              :src="tabActiveVideoUrl"
              muted
              preload
              autoplay
              loop
              v-else
            />
          </div> </swiper-slide
      ></swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import Map from '@/components/AreaComputingCenter/Map/index.vue';
export default {
  components: {
    Swiper,
    SwiperSlide,
    Map,
  },
  computed: {
    // 动态获取国际化的标签列表
    localizedTabList() {
      return [
        this.$t('dataBusiness.tabList.item1'),
        this.$t('dataBusiness.tabList.item2'),
        this.$t('dataBusiness.tabList.item3'),
      ];
    },
    // 动态获取国际化的轮播内容
    localizedSwiperItems() {
      return [
        {
          title: this.$t('dataBusiness.tab1.title'),
          subTitle: this.$t('dataBusiness.tab1.subTitle'),
          subTitle1: this.$t('dataBusiness.tab1.subTitle2'),
          btnText: this.$t('dataBusiness.tab1.btnText'),
          list: [
            {
              title: this.$t('dataBusiness.tab1.modal'),
              description: this.$t('dataBusiness.tab1.modalDesc'),
            },
            {
              title: this.$t('dataBusiness.tab1.scene'),
              description: this.$t('dataBusiness.tab1.sceneDesc'),
            },
          ],
          tabList: [
            {
              title: this.$t('dataBusiness.tab1.childTabs.item1'),
              videoUrl: 'https://img.aikesaisi.com/lkzh/www/3ddianyun.mp4',
            },
            {
              title: this.$t('dataBusiness.tab1.childTabs.item2'),
              videoUrl: 'https://img.aikesaisi.com/lkzh/www/yuyifenge.mp4',
            },
            {
              title: this.$t('dataBusiness.tab1.childTabs.item3'),
              videoUrl: 'https://img.aikesaisi.com/lkzh/www/jushenzhineng.mp4',
            },
            {
              title: this.$t('dataBusiness.tab1.childTabs.item4'),
              videoUrl: 'https://img.aikesaisi.com/lkzh/www/jianduweitiao.mp4',
            },
          ],
        },
        {
          title: this.$t('dataBusiness.tab2.title'),
          subTitle: this.$t('dataBusiness.tab2.subTitle'),
          btnText: this.$t('dataBusiness.tab2.btnText'),
          videoUrl: 'https://img.aikesaisi.com/lkzh/www/zhinengti.mp4',
          list: [
            {
              title: this.$t('dataBusiness.tab2.product'),
              description: this.$t('dataBusiness.tab2.productDesc'),
            },
          ],
        },
        {
          title: this.$t('dataBusiness.tab3.title'),
          subTitle: this.$t('dataBusiness.tab3.subTitle'),
          btnText: this.$t('dataBusiness.tab1.btnText'),
          list: [
            {
              title: this.$t('dataBusiness.tab3.capability'),
              description: this.$t('dataBusiness.tab3.capabilityDesc'),
            },
          ],
        },
      ];
    },
  },
  data() {
    return {
      swiper: null,
      activeIndex: 0,
      tabActiveIndex: 0,
      tabActiveVideoUrl: '',
      demoIcon: require('@/assets/img/pc/demo-icon.png'),
      hoveredTabIndex: -1, // 记录当前 hover 的标签索引
      hoverImgList: [
        {
          defaultSrc: require('@/assets/img/pc/motaijiansuo.png'),
          hoverSrc: require('@/assets/img/pc/motaijiansuo-1.png'),
        },
        {
          defaultSrc: require('@/assets/img/pc/zhinengti.png'),
          hoverSrc: require('@/assets/img/pc/zhinengti-1.png'),
        },
        {
          defaultSrc: require('@/assets/img/pc/kuajing.png'),
          hoverSrc: require('@/assets/img/pc/kuajing-1.png'),
        },
      ],
    };
  },
  mounted() {
    this.tabActiveVideoUrl = this.localizedSwiperItems[0].tabList[0].videoUrl;
  },
  methods: {
    scrollToAnchor() {
      window.navBarMethods.scrollToSection('contact');
    },
    handleTabClick(index) {
      this.activeIndex = index;
      this.hoveredTabIndex = -1;
      if (this.swiper) {
        this.swiper.slideTo(index);
        this.getImgSrc(index);
      }
      if (index === 1) {
        this.tabActiveVideoUrl = this.localizedSwiperItems[index].videoUrl;
      } else if (index === 0) {
        this.tabActiveVideoUrl =
          this.localizedSwiperItems[index].tabList[0].videoUrl;
        this.tabActiveIndex = 0;
      }
    },
    handleChildTabClick(index) {
      this.tabActiveIndex = index;
      this.tabActiveVideoUrl =
        this.localizedSwiperItems[0].tabList[index].videoUrl;
    },
    getImgSrc(index) {
      // 激活态优先显示 hover 图
      if (this.activeIndex === index) {
        return this.hoverImgList[index].hoverSrc;
      }
      // 仅在非激活时，hover 显示 default 图
      if (this.hoveredTabIndex === index) {
        return this.hoverImgList[index].defaultSrc;
      }
      return this.hoverImgList[index].defaultSrc;
    },
    handleTabHover(index, isHover) {
      if (this.activeIndex === index) return;
      this.hoveredTabIndex = isHover ? index : -1;
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },
  },
};
</script>
<style lang="scss" scoped>
.data-business-box {
  position: relative;
  .business-box-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    z-index: -1;
  }
  .business-box-concainter {
    padding: 120px 0;
  }
  .tab-item {
    margin-top: 60px;
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    padding: 0 20px;
    height: 47px;

    color: #222226;
    font-size: 18px;
    line-height: 50px;
    border-radius: 24px;
    transition: all 0.3s ease;

    &:not(.tab-active):hover {
      background: rgba(127, 157, 180, 0.2);
      color: #222226;
      transform: translateY(-2px);
    }

    img {
      width: 25px;
      height: 25px;
      margin-right: 5px;
      transition: all 0.3s ease;
    }
  }
  .tab-active {
    background: #222226;
    color: white;
  }
  .data-swiper-box {
    width: 100%;
    margin-top: 40px;
    height: 450px;
    background: #ffffff;
    border-radius: 20px;
    .business-swiper-item {
      display: flex;
      .business-swiper-left {
        width: 400px;
        padding: 40px;
        background: white;
        text-align: left;
        .swiper-title {
          font-weight: 600;
          white-space: nowrap;
          font-size: 30px;
          color: #222226;

          line-height: 39px;
          font-family: 'MiSans-Demibold';
          padding-bottom: 25px;
          border-bottom: #e9ebf0 1px solid;
        }
        .swiper-sub-title {
          font-weight: 400;
          font-size: 16px;
          color: #5c5c66;
          line-height: 26px;
          margin-top: 25px;
          margin-bottom: 20px;
        }
        .swiper-sub-descr {
          font-weight: 400;
          font-size: 16px;
          color: #3d3d40;
          line-height: 24px;
          margin-bottom: 10px;
          span {
            color: #222226;
            font-weight: 500;
          }
        }
        .swiper-btn {
          margin-top: 30px;
        }
      }
      .business-swiper-right {
        // flex: 1;
        position: relative;
        width: 720px;
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .swiper-child-tab-tab-item__map {
          background: var(--grid);
          // padding: 20px;
        }

        .swiper-child-tab {
          position: absolute;
          z-index: 1;
          // background: #4c4c4c;
          background: rgba(76, 76, 76, 0.8);
          display: inline-flex;
          top: 20px;
          border: 1px solid #dcdfe6; /* 外框只画一条线 */
          border-radius: 20px; /* 圆角交给外层 */
          overflow: hidden; /* 裁掉内边的直角，让左右显示圆角 */
          left: 50%;
          transform: translateX(-50%);
          flex-wrap: nowrap; /* 防止换行 */
          align-items: center; /* 垂直居中对齐 */
          .swiper-child-tab-tab-item {
            padding: 0px 15px;
            height: 32px;
            // padding-top: 3px;
            line-height: 33px;
            text-align: center;
            font-size: 14px;
            background: transparent;
            border: 0; /* 清理默认按钮边框 */
            cursor: pointer;
            color: white;
            user-select: none;
            white-space: nowrap; /* 防止文字换行 */
            min-width: fit-content; /* 确保宽度适应内容 */
            flex-shrink: 0; /* 防止收缩 */
          }
          /* “只画一条线”的关键：使用相邻兄弟选择器给左边框 */
          .swiper-child-tab-tab-item + .swiper-child-tab-tab-item {
            border-left: 1px solid white; /* 相邻项之间仅一条分隔线 */
          }
          /* 选中态 */
          .swiper-child-tab-tab-item.is-active {
            background: #fff;
            color: #222226;
          }
        }
      }
    }
  }
}
</style>
